import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "social/fb",
  "use": "social/fb-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"social/fb\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.055 0H.879C.394 0 0 .418 0 .934v15.061c0 .517.394.935.88.935h7.63v-6.556H6.435V7.819h2.077V5.934c0-2.186 1.257-3.377 3.093-3.377.88 0 1.635.07 1.855.1v2.286h-1.273c-.998 0-1.192.505-1.192 1.244V7.82h2.382l-.31 2.555h-2.072v6.556h4.06c.486 0 .88-.418.88-.934V.934c0-.516-.394-.934-.88-.934z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol